module.exports = __webpack_public_path__ + "static/10-d5bb5c8a091a698fa6e6160f2553d12a.jpg";